/*
 * Copyright (c) 2010 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.common.filter

/**
 * An event that characterizes a change in the current filter.
 */
data class SimpleFilterEvent<E>(
    override val model: Filter<E>,
    override val filtered: Iterable<E>,
    override val unfiltered: Iterable<E>) :
    AbstractFilterEvent<E>() {
}